<template>
    <div>
        <filter-sidebar-layout
            :filter-key="'filter-sidebar-tyre-truck'"
            :loading="loading"
            :fields="getFields"
            :disabled-values="disabledValues"
            v-on:change="filterValues()"
            v-on:submit="updateProductList"/>
    </div>
</template>

<script>
    import FilterSidebarLayout from "./FilterSidebarLayout";
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
    name: "TheFilterSidebarTyreTruck",
    components: {FilterSidebarLayout},
    computed: {
      ...mapState('sidebarTruckTyreModule', {
        paramInfo: 'paramInfo',
        loading: 'loading',
      }),
      ...mapGetters('sidebarTruckTyreModule', {
        isCurrentPossible: 'isCurrentPossible',
        getFields: 'getFields',
        disabledValues: 'getDisabledValues'
      }),
    },
    methods: {
      ...mapActions('sidebarTruckTyreModule', {
        filterValues: 'filterValues',
        updateProductList: 'updateProductList',
      }),
    }
  }
</script>